import { OperatorGroup } from './operator-group';

export class OperatorWeek {
  constructor(
    public year?: number,
    public week?: number,
    public startDate?: number,
    public endDate?: number,
  ) { }
}

export class OperatorWeekShift {
  constructor(
    public week?: number,
    public shift?: string,
  ) { }
}

export class OperatorGroupPlanning {
  constructor(
    public operatorGroup?: OperatorGroup,
    public shifts?: OperatorWeekShift[],
  ) { }
}

export class OperatorWeeklyPlanning {
  constructor(
    public year?: number,
    public workingModelGroupHash?: string,
    public weeks?: OperatorWeek[],
    public groups?: OperatorGroupPlanning[],
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/operator-planning.ts